import { render, staticRenderFns } from "./Breadcrumbs.component.vue?vue&type=template&id=47fa6b01&scoped=true&"
import script from "./Breadcrumbs.component.vue?vue&type=script&lang=ts&"
export * from "./Breadcrumbs.component.vue?vue&type=script&lang=ts&"
import style0 from "./Breadcrumbs.component.vue?vue&type=style&index=0&id=47fa6b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fa6b01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem})
